import gql from 'graphql-tag'
import api from './apiClient'

export default {
  readAllByEmisor: emisor =>
    api
      .send({
        query: gql`
          query READ_ALL($emisor: ID!) {
            Restaurant {
              readAllByEmisor(emisor: $emisor) {
                _id
                name
                location
                state
              }
            }
          }
        `,
        variables: {
          emisor
        }
      })
      .then(result => result.data.data.Restaurant.readAllByEmisor),

  create: input =>
    api
      .send({
        query: gql`
          mutation CREATE($input: RestaurantInput!) {
            Restaurant {
              create(input: $input) {
                _id
              }
            }
          }
        `,
        variables: {
          input
        }
      })
      .then(result => result.data.data.Restaurant.create),

  delete: input =>
    api
      .send({
        query: gql`
          mutation delete($input: [ID!]!) {
            Restaurant {
              delete(input: $input) {
                _id
                state
                message
              }
            }
          }
        `,
        variables: { input }
      })
      .then(result => result.data.data.Restaurant.delete)
}
